var Util = {
    csrfToken() {
        return document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    },

    //  formattedClassName
    formattedClassName: {
        'App\\Models\\User': 'Usuario',
        'App\\Models\\Notification': 'Notificación',
        'App\\Models\\Log': 'Log',
        'App\\Models\\Permission': 'Permiso',
        'App\\Models\\File': 'Archivo',
        'App\\Models\\Path': 'Directorio'
    },

    getFormattedClassName(className) {
        let results = this.formattedClassName[className]

        return results != undefined
            ? results
            : className
    },
    //  formattedClassName

    //  tableNameByClassName
    tableNameByClassName: {
        'App\\Models\\User': 'users',
        'App\\Models\\Notification': 'notifications',
        'App\\Models\\Log': 'logs',
        'App\\Models\\Permission': 'permissions',
        'App\\Models\\File': 'files',
        'App\\Models\\Path': 'paths'
    },

    getTableNameByClassName(className) {
        let results = this.tableNameByClassName[className]

        return results != undefined
            ? results
            : className
    },
    //  tableNameByClassName

    //  classNameByTableName
    classNameByTableName: {
        'users': 'App\\Models\\User',
        'notifications': 'App\\Models\\Notification',
        'logs': 'App\\Models\\Log',
        'permissions': 'App\\Models\\Permission',
        'files': 'App\\Models\\File',
        'paths': 'App\\Models\\Path'
    },

    getClassNameByTableName(tableName) {
        let results = this.classNameByTableName[tableName]

        return results != undefined
            ? results
            : tableName
    },
    //  classNameByTableName

    //  formattedStatus
    formattedStatus: {
        'active': 'Activo',
        'inactive': 'Inactivo',
        'created': 'Pendiente',
        'enabled': 'Habilitado',
        'disabled': 'Desabilitado'
    },

    getFormattedStatus(status, prepend = null) {
        status = prepend ? `${prepend}${status}` : status

        let results = this.formattedStatus[status]

        return results != undefined
            ? results
            : status
    },
    //  formattedStatus

    //  variantStatus
    variantStatus: {
        'active': 'success',
        'enabled': 'success',
        'inactive': 'warning',
        'disabled': 'warning'
    },

    getVariantStatus(status) {
        let results = this.variantStatus[status]

        return results != undefined
            ? results
            : status
    },
    //  variantStatus

    //  formattedObjectKeyOrValue
    formattedObjectKeyOrValue: {
        name: 'Nombre',
        email: 'Email',
        phone: 'Teléfono',
        type: 'Tipo'
    },

    getFormattedObjectKeyOrValue(key_or_value) {
        let results = this.formattedObjectKeyOrValue[key_or_value]

        return results != undefined
            ? results
            : key_or_value
    },
    //  formattedObjectKeyOrValue

    //  formattedPermission
    formattedPermission: {
        Root: 'Root'
    },

    getPermissionName(permission) {
        return this.isObject(permission)
            ? permission.name
            : permission
    },

    getFormattedPermission(permission) {
        let results = this.formattedPermission[this.getPermissionName(permission)]

        return results != undefined
            ? results
            : permission
    },
    //  formattedPermission

    buildFormData(formData, data, except, parentKey, originalKey) {
        if(!except.includes(originalKey)) {
            if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
                if(Boolean(Object.keys(data).length)) {
                    //  arreglos u objetos con datos

                    Object.keys(data).forEach(key => {
                        this.buildFormData(
                            formData,
                            data[key],
                            except,
                            parentKey ? `${parentKey}[${key}]` : key,
                            key
                        )
                    })
                } else {
                    //  arreglos u objetos vacíos
                    formData.append(parentKey, data)
                }
            } else if(data != null) {
                //  no es arreglo ni objecto y además no es nulo

                formData.append(parentKey, data)
            }
        }
    },

    jsonToFormData(object, except = []) {
        const formData = new FormData()

        this.buildFormData(
            formData,
            object,
            except,
            null,
            null
        )

        return formData
    },

    getFormattedLogType(type) {
        switch(type) {
            case 'store':
                type = `<b class='text-success'>Creado</b>`
            break

            case 'update':
                type = `<b class='text-info'>Actualizado</b>`
            break

            case 'soft deleted':
                type = `<b class='text-muted'>Borrado</b>`
            break

            case 'force deleted':
                type = `<b class='text-danger'>Destruido</b>`
            break
        }

        return type
    },

    tbodyTrClass(item, type) {
        if(type == 'row') {
            return `text-${Resource.getVariantStatus(item.status)}`
        }
    },

    getMoneyFormat(number) {
        return '$ ' + (parseFloat(number)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },

    capitalize(string) {
        return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1)
    },

    nested(o, s) {
        s = s.replace(/\[(\w+)\]/g, '.$1')
        s = s.replace(/^\./, '')
        var a = s.split('.')
        for (var i = 0, n = a.length; i < n; ++i) {
            var k = a[i]

            try {
                if (k in o) {
                    o = o[k]
                } else {
                    return;
                }
            } catch (error) {
                return;
            }
        }
        return o
    },

    getWindow() {
        return window    
    },

    substring(string, n) {
        if(typeof string == 'string' && typeof string == 'number' && string.length > n) {
            string = string.substring(0, n-3)
            string += '...'
        }

        return string
    },

    overview() {
        return {
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1200
        }
    },

    getTimestampFormat(timestamp, type = 'a') {
        if(timestamp) {
            var date = new Date(timestamp)

            switch(type) {
                case 'a':
                    return date.toDateString() + '<br>' + date.getUTCHours() + ':' + date.getUTCMinutes()
                break

                case 'b':
                    return date.toDateString() + ' - ' + date.getUTCHours() + ':' + date.getUTCMinutes()
                break

                case 'c':
                    return date.toLocaleDateString('es-MX', {day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC'})
                break;
            }
        }

        return timestamp
    },

    //  string | array
    permission(permission) {
        if(! app.$state.user) {
            return false
        }

        let permissions = []

        let userPermissions = app.$state.user.permissions.map(p => p.name)

        if(userPermissions.includes('Root')) {
            return true
        }

        if(typeof permission === 'string' || permission instanceof String) {
            permissions.push(permission)
        } else {
            permissions = permission
        }

        return userPermissions.some(p => permissions.indexOf(p) !== -1)
    },

    changeObjectKeys(object) {
        for(var property in object) {
            if(object.hasOwnProperty(property)) {
                if(typeof object[property] == "object") {
                    this.changeObjectKeys(object[property]);
                }else {
                    let new_key = this.getFormattedObjectKeyOrValue(property)
                    
                    object[new_key] = this.getFormattedObjectKeyOrValue(object[property])

                    if(new_key != property) {
                        delete object[property]
                    }
                }
            }
        }
    },

    groupBy(objectArray, property) {
       return objectArray.reduce((acc, obj) => {
          const key = obj[property];
          if (!acc[key]) {
             acc[key] = [];
          }

          acc[key].push(obj);
          return acc;
       }, {});
    },

    dynamicResources: {},

    loadDynamicResource(id, tag, src, attributes = {}) {
        if(! this.dynamicResources[id]) {
            this.dynamicResources[id] = {
                id: id,
                promise: new Promise((success, reject) => {
                    let resource = document.createElement(tag)
                
                    resource.id = id
                    resource.src = src
                    resource.onload = success
                    resource.onerror = reject
        
                    for (var [key, value] of Object.entries(attributes)) {
                        resource.setAttribute(key, value)
                    }
        
                    document.head.appendChild(resource)
                })
            }
        }

        return this.dynamicResources[id].promise
    },

    getEntityUrl1() {
        let split = window.location.pathname.split('/')
        let length = split.length

        return `${split[length-2]}/${split[length-1]}`
    },

    getSlug() {
        return window.location.pathname.split('/').pop()
    },

    isSameResource(resource1, resource2, keys = ['id']) {
        if(typeof resource1 != 'object' || typeof resource2 != 'object') {
            return false
        }

        let same = true

        keys.forEach(k => {
            if(_.get(resource1, k) != _.get(resource2, k)) {
                same = false
            }
        })

        return same
    },

    isObject(item) {
        return (item && typeof item === 'object' && !Array.isArray(item));
    },

    mergeRecursive(target, ...sources) {
        if (!sources.length) return target
        
        const source = sources.shift()

        if (this.isObject(target) && this.isObject(source)) {
            for (const key in source) {
                if (this.isObject(source[key])) {
                    if (!target[key]) Object.assign(target, { [key]: {} });
                    this.mergeRecursive(target[key], source[key]);
                } else {
                    Object.assign(target, { [key]: source[key] });
                }
            }
        }

        return this.mergeRecursive(target, ...sources);
    },

    getApiUrlByResource(resource) {
        let apiUrlByResource = '#'

        try {
            let table = resource.table
            let slug = resource.alias ? resource.alias : resource.id

            if(table && slug) {
                apiUrlByResource = route(`api.${table}.show`, slug)
            }
        } catch(e) {
            //
        }

        return apiUrlByResource
    },

    getPageByResource(resource, context = 'admin') {
        let pageByResource = '#'

        try {
            let classname = this.getClassNameByTableName(resource.table).split('\\').pop().toLowerCase()
            let slug = resource.alias ? resource.alias : resource.id

            pageByResource = route(`pages.${context}.${classname}`, slug)            
        } catch(e) {
            //
        }

        return pageByResource
    },

    getResourceName(resource) {
        return  resource.name
            ? resource.name
            : resource.title
                ? resource.title
                : resource.id
    },

    clone(object) {
        return JSON.parse(JSON.stringify(object))
    },

    getMessageFromError(error) {
        try {
            return Object.values(error.response.data.errors)[0][0]
        } catch (e) {
            //
        }

        try {
            return error.response.data.message
        } catch (e) {
            //
        }

        try {
            return error.message
        } catch (e) {
            //
        }

        return error ?? 'Error desconocido'
    }
}

export default Util